import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function PeruAlertasTempranas2026Layer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="0"
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url="https://gis.bosques.gob.pe/server/services/Interoperabilidad/alertas_tempranas_2026/MapServer/WMSServer"
      opacity={opacity}
    />
  )
}

export default PeruAlertasTempranas2026Layer
